// extracted by mini-css-extract-plugin
module.exports = {"titleCase":"_bb70f6d"};